"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RevolutionizeYourHardscapeBusiness() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: btnRef,
    isVisible: isBtnVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223314" id="revolutionize-your-hardscape-business" className="relative min-h-[100svh] flex items-center justify-center overflow-hidden bg-background dark">
            {}
            <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_waterfall_assembly_cinematic.png')] bg-cover bg-center bg-fixed opacity-60" />

            {}
            <div className="absolute inset-0 z-0 bg-black/50" />

            {}
            <div className="relative z-10 flex flex-col items-center justify-center text-center px-6 md:px-12 max-w-5xl mx-auto gap-10">
                <h1 ref={titleRef} className={`text-5xl md:text-7xl lg:text-8xl font-default font-bold tracking-tight text-white transition-all duration-1000 ease-out ${isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                    REVOLUTIONIZE YOUR HARDSCAPE BUSINESS
                </h1>

                <p ref={textRef} className={`text-lg md:text-2xl text-white/90 font-default max-w-3xl font-medium leading-relaxed transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                    Build faster. Earn more. Less labor. Discover the panel masonry system designed for the modern outdoor living contractor.
                </p>

                <div ref={btnRef} className={`transition-all duration-1000 delay-500 ease-out ${isBtnVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                    <Button asChild size="lg" className="rounded-md px-10 py-7 text-lg bg-primary text-primary-foreground shadow-lg hover:shadow-primary/40 hover:bg-primary/90 transition-all duration-500 hover:-translate-y-1 animate-pulse">
                        <Link to="/ApplyNowPage">Become a ClifRock Installer</Link>
                    </Button>
                </div>
            </div>
        </section>;
}